export default function favoritesPage() {
  return {
    isLoading: false,
    selectedSkills: [] as string[],

    get favorites() {
      return (this as any).$store.favorites.items;
    },

    confirmClear() {
      (this as any).$store.favorites.clear();
    },

    init() {
      if (this.favorites.length > 0) {
        this.fetchJobs();
      }

      // Re-fetch if favorites change
      (this as any).$watch("$store.favorites.items", (value: string[]) => {
        if (value.length > 0) {
          this.fetchJobs();
        } else {
          const container = document.getElementById("job-list-container");
          if (container) container.innerHTML = "";
        }
      });
    },

    async fetchJobs() {
      this.isLoading = true;
      try {
        const params = new URLSearchParams();
        if (this.favorites.length > 0) {
          params.append("slugs", this.favorites.join(","));
        }

        const response = await fetch("/partials/jobs?" + params.toString());
        if (response.ok) {
          const html = await response.text();
          const container = document.getElementById("job-list-container");
          if (container) container.innerHTML = html;
        }
      } catch (e) {
        console.error("Failed to fetch favorite jobs", e);
      } finally {
        this.isLoading = false;
      }
    },
  };
}
